import {
  ProductCollection,
  BreadcrumbsSlice,
  ProductsSlice,
  MetaDataSlice,
  ProductCollectionSlice,
} from '../../types';

type Props = {
  data: {
    productCollection: ProductCollection;
  };
};

const getSlice = <T extends ProductCollectionSlice>(
  slices: ProductCollectionSlice[],
  type: string
): T | undefined =>
  Array.isArray(slices)
    ? slices.find((slice): slice is T => slice.__typename === type)
    : undefined;

export default ({ data }: Props) => {
  if (!data || !data.productCollection) {
    return {};
  }

  const { slices } = data.productCollection;
  const metaData = getSlice<MetaDataSlice>(slices, 'MetaDataSlice');
  const breadcrumb = getSlice<BreadcrumbsSlice>(slices, 'BreadcrumbsSlice');
  const products = getSlice<ProductsSlice>(slices, 'ProductsSlice');

  if (!metaData) {
    return {};
  }
  const noIndex = !products || products.nodes.length === 0;
  const { title, name, description, hrefLang, image, url: metaUrls } = metaData;
  const { current, next, prev } = metaUrls || {};

  return {
    title,
    description,
    canonical: current,
    noIndex,
    breadcrumb: breadcrumb && breadcrumb.items,
    openGraph: [
      {
        key: 'title',
        content: name,
      },
      {
        key: 'url',
        content: current,
      },
      {
        key: 'desc',
        content: description,
      },
      {
        key: 'type',
        content: 'product.group',
      },
      {
        key: 'image',
        content: image,
      },
    ],
    thumbnail: image,
    hrefLang,
    next,
    prev,
  };
};
